module.exports = __webpack_public_path__ + "static/media/Buters.984d98ed.mp3";